import './LabelWithTooltip.scss';

export { default } from './LabelWithTooltip';
